import type { ComponentProps } from "react"
import { forwardRef } from "react"

interface Props extends ComponentProps<"svg"> {
	color?: string
}

export const PlannedIcon = forwardRef<SVGSVGElement, Props>(
	({ color, ...props }, ref) => (
		<svg
			viewBox="2 1.2363 12 13.5269"
			fill={color || "currentColor"}
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.5 5.36133L8 2.73633L3.5 5.36133L3.5 10.6382L8 13.2632L12.5 10.6382L12.5 5.36133ZM8.75581 1.44066C8.28876 1.16822 7.71124 1.16822 7.24419 1.44066L2.74419 4.06566C2.28337 4.33448 2 4.82783 2 5.36133V10.6382C2 11.1717 2.28337 11.6651 2.74419 11.9339L7.24419 14.5589C7.71124 14.8313 8.28876 14.8313 8.75581 14.5589L13.2558 11.9339C13.7166 11.6651 14 11.1717 14 10.6382V5.36133C14 4.82783 13.7166 4.33448 13.2558 4.06566L8.75581 1.44066Z"
			></path>
		</svg>
	),
)
